const CART_TIMER_KEY = "cart_timer_end";
const CART_TIMER_DURATION = 15 * 60 * 1000;

function initCartTimer() {
  const timer = document.getElementById("cart-countdown");

  if (!timer || timer.dataset.initialized) return;

  timer.dataset.initialized = "true";

  let end = parseInt(localStorage.getItem(CART_TIMER_KEY));

  if (!end || end < Date.now()) {
    end = Date.now() + CART_TIMER_DURATION;
    localStorage.setItem(CART_TIMER_KEY, end);
  }

  function update() {
    const diff = end - Date.now();

    if (diff <= 0) {
      end = Date.now() + CART_TIMER_DURATION;
      localStorage.setItem(CART_TIMER_KEY, end);
      return;
    }

    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    timer.textContent =
      `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  }

  update();

  setInterval(update, 1000);
}

document.addEventListener("DOMContentLoaded", initCartTimer);

const observer = new MutationObserver(() => {
  initCartTimer();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});